import { render, staticRenderFns } from "./c360.vue?vue&type=template&id=6716ce98&scoped=true&"
import script from "./c360.vue?vue&type=script&lang=js&"
export * from "./c360.vue?vue&type=script&lang=js&"
import style0 from "./c360.vue?vue&type=style&index=0&id=6716ce98&lang=stylus&scoped=true&"
import style1 from "./c360.vue?vue&type=style&index=1&id=6716ce98&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6716ce98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6716ce98')) {
      api.createRecord('6716ce98', component.options)
    } else {
      api.reload('6716ce98', component.options)
    }
    module.hot.accept("./c360.vue?vue&type=template&id=6716ce98&scoped=true&", function () {
      api.rerender('6716ce98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/video/c360.vue"
export default component.exports